// "1 archivo" / "3 archivos"
export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;


export const EMPTY = "—";

const nf = new Intl.NumberFormat("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const UNITS = { M: "meses", D: "días", W: "semanas", Y: "años", A: "años" };

export const isEmpty = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "") || (typeof v === "number" && Number.isNaN(v));

export function formatDate(v) {
  if (isEmpty(v)) return EMPTY;
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(v);
}

export function formatMoney(v, currency) {
  if (isEmpty(v)) return EMPTY;
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return `${n < 0 ? "-" : ""}$${nf.format(Math.abs(n))}${currency ? ` ${currency}` : ""}`;
}

export function formatPercent(v) {
  if (isEmpty(v)) return EMPTY;
  const n = Number(v);
  return Number.isNaN(n) ? String(v) : `${(n * 100).toFixed(2)}%`;
}

function formatTermUnit(v) {
  if (isEmpty(v)) return EMPTY;
  const unit = UNITS[String(v).trim().toUpperCase()];
  return unit ? `${v} (${unit})` : String(v);
}

export function formatField(field, currency) {
  switch (field.format) {
    case "money":
      return formatMoney(field.value, currency);
    case "date":
      return formatDate(field.value);
    case "percent":
      return formatPercent(field.value);
    case "term_unit":
      return formatTermUnit(field.value);
    default:
      return isEmpty(field.value) ? EMPTY : String(field.value);
  }
}

export function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function formatDateTime(iso) {
  const s = String(iso);
  const d = new Date(/Z$|[+-]\d{2}:\d{2}$/.test(s) ? s : `${s}Z`);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function formatTime(iso) {
  const s = String(iso);
  const d = new Date(/Z$|[+-]\d{2}:\d{2}$/.test(s) ? s : `${s}Z`);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
